import { colors } from '@/constants';
import { CardMode } from '@/types';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { RiExchangeDollarLine } from 'react-icons/ri';

export const ContentInfos = styled.div<{ direction?: CardMode }>`
  display: flex;
  flex-direction: ${(i) => (i.direction === 'grid' ? 'column' : 'column-reverse')};
`;

export const ProductLink = styled(Link)`
  text-decoration: none;
`;

export const Div = styled.div`
  width: 100%;
`;

export const CustomDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export const Row = styled.div<{ $checkSize?: boolean; $isList?: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;

  justify-content: space-between;

  @media screen and (max-width: 430px) {
    flex-direction: ${({ $checkSize }) => ($checkSize ? 'column' : 'row')};
    .selo-campanha {
      overflow-y: auto;
    }
  }
  @media screen and (max-width: 330px) {
    flex-direction: ${({ $checkSize, $isList }) => ($checkSize && $isList ? 'row' : 'column')};
  }
`;

export const EditIcon = styled(RiExchangeDollarLine)``;

export const ExpiringText = styled.span<{ $severity?: 'danger' | 'warning' | 'normal' }>`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 600;
  color: ${({ $severity }) =>
    $severity === 'danger' ? colors.alert.red200 : $severity === 'warning' ? colors.alert.orange300 : colors.brand.grafite};
`;

export const PriceContent = styled.div<{ $isList?: boolean; $bordered?: boolean; hasComboDiscount?: boolean }>`
  gap: 10px;
  width: 100%;
  margin-top: -2px;
  align-items: start;
  display: flex;
  flex-direction: ${(i) => (i.$isList ? 'row' : 'column')};
  justify-content: space-between;
  padding: 16px;
  border: ${(i) => (i.$bordered ? `2px solid ${colors.brand.grafite}` : 'none')};
  border-radius: 0 0 6px 6px;
  background-color: ${colors.brand.white};

  height: ${(i) => (i.$isList ? '116px' : 'auto')};
  ${({ hasComboDiscount }) => hasComboDiscount && css`
    height: 146px;
  `}
`;

export const Content = styled.div`
  padding-bottom: 30px;
`;

export const ColPrice = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const RowPrice = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

export const RowPriceSt = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 4px;
`;

export const CustomPrice = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: ${colors.brand.grafite};
  line-height: 120%;
`;

export const StPrice = styled.span`
  font-size: 12px;
  font-weight: 400;
  color: ${colors.brand.grafite};
  line-height: 120%;
`;

export const ButtonFlex = styled.button<{ $isdisabled?: boolean; $isList?: boolean; $flexState?: 'positive' | 'negative' }>`
  gap: 4px;
  border: ${(i) =>
    i.$isdisabled
      ? 'none'
      : `1px solid ${i.$flexState === 'positive' ? colors.alert.green100 : i.$flexState === 'negative' ? colors.alert.orange100 : colors.grey11}`};
  display: flex;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  border-radius: 6px;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  /* padding: 8px 16px 8px 16px; */
  color: ${(i) =>
    i.$isdisabled
      ? colors.brand.grafite
      : i.$flexState === 'positive'
        ? colors.alert.green110
        : i.$flexState === 'negative'
          ? colors.alert.orange300
          : colors.brand.grafite};
  opacity: ${(i) => (i.$isdisabled ? 0.3 : 1)};
  background-color: ${(i) => {
    if (i.$isdisabled) return colors.gray.gray10;
    if (i.$flexState === 'positive') return colors.alert.green100;
    if (i.$flexState === 'negative') return colors.alert.orange100;
    return colors.gray.gray10;
  }};
  width: ${(i) => (i.$isList ? '83px' : '100%')};
  height: ${(i) => (i.$isList ? '64px' : '36px')};
`;

export const FlexInfo = styled.span`
  font-size: 12px;
  font-weight: 700;
  margin-left: 6px;
`;

export const ProductCard = styled.div<{ $showSelo?: boolean }>`
  gap: 1rem;
  height: 100%;
  mask-border: 20px;
  border-radius: 10px;
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: column;
  -webkit-box-pack: justify;
  justify-content: space-between;

  background: ${({ $showSelo }) => ($showSelo ? colors.alert.green50 : colors.brand.white)};
  box-shadow: ${({ $showSelo }) => ($showSelo ? `0px 4px 20px 0px ${colors.alert.green110}` : `${colors.shadown1} 0px 0px 8px`)};
  border: ${({ $showSelo }) => ($showSelo ? `2px solid ${colors.alert.green110}` : 'none')};
`;

export const ProductContainer = styled.div`
  height: 100%;
  width: 100%;
`;

export const ProductContent = styled.div<{ direction?: CardMode }>`
  flex: 1;
  display: flex;
  height: 100%;
  transition: all 0.5s !important;
  flex-direction: column;
  width: -webkit-fill-available;
  justify-content: space-between;
  padding: ${(i) => (i.direction === 'grid' ? '10px' : '20px')};
`;

export const ProductImage = styled.img<{ $isList?: boolean }>`
  width: 100%;
  aspect-ratio: 1/1;
  object-fit: contain;
`;

export const PaymentCondition = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;

  width: fit-content;
  margin-bottom: 12px;
  padding: 8px;
  border-radius: 6px;
  background-color: ${colors.grey10};

  font-size: 11px;
  font-weight: 600;
  line-height: 12.89px;
  color: ${colors.gray.gray50};

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const BtnAdd = styled.button`
  gap: 4px;
  width: 100%;
  border: none;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  border-radius: 6px;
  padding: 10px 25px;
  align-items: center;
  display: inline-flex;
  justify-content: center;
  color: ${colors.brand.white};
  background: ${colors.brand.red};
`;

export const BtnAddList = styled.button<{ $grey?: number; $hasExpiring?: boolean; $expiringStatus?: string }>`
  width: 32px;
  height: 32px;
  border-radius: 6px;
  border: none;
  display: inline-flex;
  padding: 0px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  background-color: ${({ $grey, $hasExpiring, $expiringStatus }) =>
    $hasExpiring && $expiringStatus === 'warning'
      ? colors.alert.orange50
      : $hasExpiring && $expiringStatus === 'danger'
        ? colors.alert.red50
        : $grey
          ? colors.gray.gray10
          : colors.brand.red};
`;

export const ProductCode = styled.div<{ $showSelo?: boolean }>`
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  white-space: nowrap;

  color: ${colors.brand.grafite};
  font-size: 13px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  padding: 0 8px;
  border-radius: 4px;
  /* line-height: 140%; */
  background-color: ${(i) => (i.$showSelo ? colors.alert.green100 : colors.gray.gray10)};
`;

export const CommissionFlag = styled.span<{ $showSelo?: boolean }>`
  width: 20px;
  height: 20px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 4px;
  background-color: ${(i) => (i.$showSelo ? colors.alert.green100 : colors.gray.gray10)};

  font-size: 12px;
  font-weight: 600;
  color: ${colors.brand.grafite};
`;

export const SelectEmbalagem = styled.p`
  text-align: center;
  font-size: 11px;
  margin-bottom: 0px;
  flex: 1;
  margin: 0px;
  white-space: pre;
  font-weight: 400;
  color: ${colors.gray.gray60};
`;

export const Container = styled.div<{ direction?: CardMode }>`
  display: flex;
  gap: ${(i) => (i.direction === 'grid' ? '0px' : '12px')};
  flex-direction: ${(i) => (i.direction === 'grid' ? 'column' : 'row')};
  flex-grow: 1;
  @media screen and (max-width: 430px) {
    flex-direction: ${({ direction }) => (direction === 'list' ? 'row' : 'column')};
  }
  @media screen and (max-width: 330px) {
    flex-direction: column !important;
  }
`;

export const ContentWrapper = styled.div`
  width: 100%;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ContentImage = styled(Link)<{ direction?: CardMode }>`
  width: 64px;
  height: 64px;
  display: flex;
  background: ${colors.brand.white};
`;

export const PaddingImage = styled.div<{ direction?: CardMode }>`
  position: relative;
  padding-bottom: 5px;

  padding: ${(i) => (i.direction === 'grid' ? '15%' : '0px')};

  @media screen and (max-width: 330px) {
    max-width: 100% !important;
    a {
      display: block;
      text-align: center;
    }
  }
`;

export const DescProduct = styled.div`
  font-size: 14px;
  font-weight: 700;
  font-family: Roboto, sans-serif;
  line-height: 140%;
  width: 100%;

  height: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;

  text-align: left;
  padding: 0;
  color: ${colors.gray.gray60};
`;

export const BoxQtdEmbalagem = styled.div`
  padding: 8px 10px;
  margin-bottom: 10px;
  border-radius: 0px 6px 6px;
  background-color: ${colors.gray.gray10};
`;

export const QtdEmbalagem = styled.div`
  white-space: nowrap;
  font-weight: 400;
  font-size: 11px;
  text-align: left;
  line-height: 120%;
  margin-bottom: 0px;
  color: ${colors.gray.gray60};
`;

export const BoxEmbalagem = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  -webkit-box-pack: center;
  justify-content: center;
  gap: 5px;
  -webkit-box-align: center;
  align-items: center;
  width: 50px;
  height: 50px;
  padding-top: 7px;
  border-radius: 6px 6px 0px 0px;
  cursor: pointer;
  border-top: 2px solid ${colors.gray.gray50};
  background-color: ${colors.gray.gray10};
`;

export const BoxLabel = styled.p`
  color: ${colors.gray.gray50};
  text-align: center;
  font-size: 9px;
  font-weight: 500;
  margin: 0px;
  line-height: normal;
`;

export const Price = styled.p<{ $combo?: boolean }>`
  margin: 0px;
  display: flex;
  font-weight: 700;
  line-height: normal;
  font-size: 14px;
  text-align: left;
  color: ${colors.brand.grafite};

  ${({ $combo }) =>
    $combo &&
    css`
      color: ${colors.brand.red};
    `}
`;

export const UnitPrice = styled.p<{ $combo?: boolean }>`
  margin: 0px;
  color: ${colors.brand.grafite};
  font-size: 16px;
  line-height: normal;
  text-align: left;
  font-weight: 700;
  line-height: 120%;

  ${({ $combo }) =>
    $combo &&
    css`
      color: ${colors.brand.red};
    `}
`;

export const Underline = styled.p`
  margin: 0px;
  display: flex;
  line-height: normal;
  font-weight: 400;
  font-size: 12px;
  text-decoration-line: line-through;
  color: ${colors.gray.gray40};
`;

export const Line = styled.div`
  width: auto;
  flex: auto;
  height: 1px;
  background-color: ${colors.gray.gray10};
`;

export const LabelSelectEmbalagem = styled.div`
  gap: 5px;
  line-height: 10px;
  margin-bottom: 5px;
  display: flex;
  grid-column: auto;
  align-items: center;
`;

export const ContentChevron = styled.div`
  line-height: 1px;
  margin-bottom: 2px;
  text-align: center;
`;

export const Promocao = styled.img`
  position: absolute;
  left: 0px;
  top: 0px;
`;

export const AddList = styled.div`
  display: flex;
  gap: 4px;
  flex-direction: row;
  padding-top: 4px;
`;

export const TimeContent = styled.div`
  top: 0px;
  left: 0px;
  z-index: 9;
  overflow: hidden;
  position: absolute;
  border-radius: 6px;
  border: 1px solid ${colors.brand.red};
`;

export const Time = styled.div`
  display: inline-flex;
  justify-content: center;
  background: ${colors.brand.red};
  align-items: center;
  gap: 4px;
  padding: 4px;
`;

export const TimerText = styled.div`
  font-size: 11px;
  font-weight: 700;
  line-height: 9px;
  color: ${colors.brand.white};
  text-align: center;
`;

export const TimeLabel = styled.div`
  font-size: 11px;
  font-weight: 700;
  padding: 4px 0px;
  text-align: center;
  background: ${colors.brand.white};
`;

export const InfoRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 8px;
`;

export const EanWrapper = styled.div<{ $isList?: boolean }>`
  display: flex;
  flex-direction: ${({ $isList }) => ($isList ? 'row' : 'column')};
  align-items: ${({ $isList }) => ($isList ? 'center' : 'flex-start')};
  flex-wrap: wrap;
  justify-content: space-between;
  flex-grow: 1;
  gap: 4px;
`;

export const ContentRow = styled.div<{ $isList?: boolean }>`
  display: flex;
  flex-direction: ${(i) => (i.$isList ? 'row' : 'column')};
  align-items: center;
  gap: 12px;
  width: 100%;

  @media screen and (max-width: 330px) {
    flex-direction: column;
  }
`;

export const LastPurchaseBox = styled.div<{ $grid?: boolean | undefined }>`
  display: flex;
  flex-direction: column;
  gap: 4px;

  border-radius: 0px 0px 6px 6px;
  border: ${({ $grid }) => ($grid ? 'none' : `1px solid ${colors.gray.gray10}`)};
  border-top: none;
  padding: ${({ $grid }) => ($grid ? '12px' : '12px')};

  /* margin-top: ${({ $grid }) => ($grid ? '0' : '-')}; */
  background-color: ${colors.brand.white};
`;

export const LastPurchaseRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 4px;
  align-items: flex-end;

  color: ${colors.brand.grafite};
  font-size: 14px;
`;

export const LastPurchaseText = styled.span`
  font-weight: 400;
`;

export const LastPurchaseBold = styled.span`
  font-weight: 700;
`;

export const Space = styled.div`
  flex-grow: 1;
  margin: 0 4px;
  background-color: transparent;
  border-bottom: 2px solid ${colors.gray.gray10};
  height: 2px;
`;
